const FARMI_APP_LOCAL_STORAGE_KEY = 'Farmi-Mobile-Access-Token';
export function authService() {
    return {
        getAccessToken: getAccessToken(),
        refreshAccessToken: getAccessToken(),
        getScopes: () => Promise.resolve([]),
        isAuthenticated: () => {
            return Promise.resolve(getAccessTokenFromLocalStorage() !== null);
        },
        signin: () => Promise.resolve(),
        logout: () => Promise.resolve(),
        login: () => Promise.resolve(),
        onUserLogged: () => Promise.resolve(),
        checkUserAuthSession: () => Promise.resolve(),
    };
}
function getAccessToken() {
    return () => Promise.resolve(getAccessTokenFromLocalStorage());
}
export function getAccessTokenFromLocalStorage() {
    return localStorage.getItem(FARMI_APP_LOCAL_STORAGE_KEY);
}
//# sourceMappingURL=index.js.map